import {
  gradientFilter,
  gradientFloodsFilter,
  polygonsFilter,
} from './filters.js';

export const filterHexagons = (hexagons, filters) => {
  const filteredHexagons = hexagons.filter((item) => {
    if (!gradientFilter(filters, item)) return false;
    if (!polygonsFilter(filters, item)) return false;
    return true;
  });

  return filteredHexagons;
};

export const filterFloods = (polygons, filters) => {
  const filteredPolygons = polygons.filter((item) => {
    if (!gradientFloodsFilter(filters, item)) return false;
    return true;
  });

  return filteredPolygons;
};
